import get from 'lodash/get';
import { formatUrl } from '../helpers/formatUrl';
/**
 * Try to detect error during the connection state and close the connection
 * if the response is in error to avoid infinite polling.
 */
// $FlowFixMe[missing-local-annot]
const isConnectionFails = response => get(response, 'currentTarget.readyState', undefined) === 0 && get(response, 'type') === 'error';
export class Client {
  constructor(url, params = {}, listeners = {}) {
    this.url = url;
    this.params = params;

    // call a listener with decoded response if possible
    // $FlowFixMe[missing-local-annot]
    const decodeResponse = listener => response => {
      if (isConnectionFails(response)) {
        this.close();
        return;
      }
      if (listeners[listener]) {
        let data = null;
        try {
          data = JSON.parse(response.data);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.warn('Error when decoding the response from SSE event');
        }
        listeners[listener]({
          data
        });
      } else {
        // eslint-disable-next-line no-console
        console.warn(`No listener for event ${listener}`);
      }
    };

    // wrap passed listeners to do extra stuff
    // like decoding response or closing the connection.
    this.listeners = {
      giveupJob: decodeResponse('giveupJob'),
      response: decodeResponse('response'),
      error: decodeResponse('error'),
      done: () => {
        if (listeners.done) {
          listeners.done();
        }
        this.close();
      }
    };
    this.sseUrl = formatUrl(this.url, this.params);
    this.evtSource = new EventSource(this.sseUrl);
    Object.keys(this.listeners).forEach(event => {
      this.evtSource.addEventListener(event, this.listeners[event], false);
    });
  }

  /**
   * Remove listeners from the event source object
   * and close the connection.
   */
  close() {
    Object.keys(this.listeners).forEach(event => {
      this.evtSource.removeEventListener(event, this.listeners[event]);
    });
    this.evtSource.close();
  }
}